import { ApiContract, HttpMethods } from '@tc/http';
import { Api } from '../../configuration/Api';

/**
 * Contract for retrieving global notifications.
 */
@ApiContract({ endpoint: Api.getGlobalNotifications, httpMethod: HttpMethods.get })
export class ApiGetGlobalNotifications {
  constructor() {}
}
